import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {ElementMouseEvent} from 'util/Types';

import {Row} from './ReorderableSimpleTableConstants';

export interface ReorderableSimpleTableRowProps {
  row: Row;
  isDraggingDisabled: boolean;
  isDragging?: boolean;
  onDragStart?: (e: ElementMouseEvent) => void;
  rowContainerClassName?: string;
  rowClassName?: string;
  dragHandleClassName?: string;
}

export default function ReorderableSimpleTableRow(props: ReorderableSimpleTableRowProps): JSX.Element {
  return (
    <div
      className={classNames('simpleDivTable-rowContainer', props.rowContainerClassName, {
        'is-dragging': props.isDragging,
      })}
      {...getTestProps({component: 'ReorderableSimpleTableRow', element: 'root'})}
    >
      <a
        className={classNames(
          'u-primary-pointer simpleDivTable-action simpleDivTable-action--move',
          props.dragHandleClassName,
          {
            faded: !props.isDragging,
            'u-primary-color': props.isDragging,
            invisible: props.isDraggingDisabled,
          }
        )}
        {...getTestProps({component: 'FieldTableRow', element: 'link'})}
        onMouseDown={props.onDragStart}
      >
        <BenchlingIcon icon="grip-dots-vertical" />
      </a>
      <div className={classNames('simpleDivTable-row', props.rowClassName)}>
        {props.row.cells.map((cell, index) => (
          <div
            key={cell.key}
            className={classNames('simpleDivTable-cell', cell.cellClassName)}
            {...getTestProps({component: 'ReorderableSimpleTableRowCell', key: cell.key})}
            data-amp-safe={false}
          >
            <div
              className={classNames('u-small-spacing-right u-ellipsis-text', cell.contentsClassName)}
              {...getTestProps({component: 'ReorderableSimpleTableRowCell', element: 'row'})}
            >
              {cell.contents}
            </div>
          </div>
        ))}
        {props.row.actionGroup && (
          <div className={classNames(css(styles.outerMargin), 'simpleDivTable-actionGroupContainer')}>
            {props.row.actionGroup}
          </div>
        )}
      </div>
    </div>
  );
}

export const styles = StyleSheet.create({
  outerMargin: {marginRight: '8px'},
});
